// extracted by mini-css-extract-plugin
export default {"header":"style-module__MxqAO"};